import { createSelector } from 'reselect';

const selectaddressBooks = (state: any) => state.addressBooks;


export const selectaddressBookCurrentItem = createSelector([selectaddressBooks], (addressBooks) => addressBooks.current);

export const selectaddressBooksListItems = createSelector([selectaddressBooks], (addressBooks) => addressBooks.list);

export const selectaddressBookItemById = (itemId: any) =>
    createSelector(selectaddressBooksListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectaddressBookQueryItems = createSelector([selectaddressBooks], (addressBooks) => addressBooks.query);

export const selectaddressBookCreatedItem = createSelector([selectaddressBooks], (addressBooks) => addressBooks.create);

export const selectaddressBookUpdatedItem = createSelector([selectaddressBooks], (addressBooks) => addressBooks.update);

export const selectaddressBookReadItem = createSelector([selectaddressBooks], (addressBooks) => addressBooks.read);

export const selectaddressBookDeletedItem = createSelector([selectaddressBooks], (addressBooks) => addressBooks.delete);

export const selectSearchedItems = createSelector([selectaddressBooks], (addressBooks) => addressBooks.search);

export const selectaddressBookItemsCount = createSelector([selectaddressBooks], (addressBooks) => addressBooks.count);

export const selectaddressBookItemsFilter = createSelector([selectaddressBooks], (addressBooks) => addressBooks.filter);